<tax-page-header titleText="organization.title"></tax-page-header>

<div class="ui-kit-content-container">
  <!--TODO: fix $any-->
  <tax-edit-legal
    *ngIf="organizationType === OrganisationType.Legal"
    [organization]="$any(organization)"
    (goBack)="goToOrganisationPage()"
    (submitForm)="submitForm($event)"
  ></tax-edit-legal>
  <!--TODO: fix $any-->
  <tax-edit-individual
    *ngIf="organizationType === OrganisationType.Individual"
    [organization]="$any(organization)"
    (goBack)="goToOrganisationPage()"
    (submitForm)="submitForm($event)"
  ></tax-edit-individual>
</div>
